<template>
  <div class='mine'>

    <div class="title">
      <!-- <img src="@/assets/serve/problem/text.png" alt=""> -->
    </div>

    <div class="proBox">
      
      <div class="proClass">
        <!-- <div class="classTit">小森有礼</div> -->
        <!-- <div @click="selClass(item.id)" v-for="item in xsList" :key="item.id" :class="classIndex === item.id? 'classItem selItem': 'classItem'">{{ item.class_name }}</div> -->
        <div class="classTit">设计之家</div>
        <div @click="selClass(item.id)" v-for="item in deList" :key="item.id" :class="classIndex === item.id? 'classItem selItem': 'classItem'">{{ item.class_name }}</div>
        <div class="classTit">家居焕新</div>
        <div @click="selClass(item.id)" v-for="item in hxList" :key="item.id" :class="classIndex === item.id? 'classItem selItem': 'classItem'">{{ item.class_name }}</div>
      </div>

      <div class="proList">
        <div class="user_info">
          <div class="img">
            <img :src="userImg()" alt="">
          </div>
          <div class="nick">{{ userInfo.nick }}</div>
          <el-upload
            class="tx"
            action="#"
            :show-file-list="false"
            :http-request="afterReadheadPic">
            <button class="tx">换头像</button>
          </el-upload>
          <button class="msg" @click="editUserInfo">编辑个人资料</button>
        </div>

        <myPost v-if="classIndex === 3" :userInfo="userInfo"></myPost>
        <contribute v-if="classIndex === 5" :userInfo="userInfo"></contribute>
        <desConsuit v-if="classIndex === 6"></desConsuit>
        <recommend v-if="classIndex === 2"></recommend>
        <renewBookList v-if="classIndex === 7"></renewBookList>

        <!-- <div v-for="(item, index) in list" :key="index" class="list-item">

          <div class="top" @click="showItem(index)">
            <div class="line"></div>
            <span>{{ item.question_name }}</span>
          </div>
          <el-collapse-transition>
            <div v-show="index === selIndex" class="bot">{{ item.question_answer }}</div>
          </el-collapse-transition>

        </div> -->
      </div>

    </div>
    <DesignerSignup v-if="showDesignSignup" :show="showDesignSignup" :userInfo="userInfo" @close="showDesignSignup = false"></DesignerSignup>
    <ActivitySignup v-if="showActivitySignup" :show="showActivitySignup" :userInfo="userInfo" @close="showActivitySignup = false"></ActivitySignup>
  </div>
</template>

<script>
import { upload } from '@/api/tools.js'
import { editInfo } from '@/api/login.js'
import desConsuit from './component/desConsulting.vue'
import contribute from './component/contribute.vue'
import DesignerSignup from "@/components/designerSignup.vue"
import ActivitySignup from "@/components/activitySignup.vue"
import myPost from './component/myPost.vue'
import recommend from './recommend.vue'
import renewBookList from './component/renewBookList.vue'

export default {
  name: 'mine',
  components: {
    desConsuit,
    contribute,
    DesignerSignup,
    ActivitySignup,
    myPost,
    recommend,
    renewBookList
  },
  props: {
    userInfo: {}
  },
  data() {
    return {
      classIndex: '',
      xsList: [
        { class_name: '我要报名', id: 1 },
        { class_name: '我的推荐', id: 2 },
        { class_name: '我的报名', id: 3 }
      ],
      deList: [
        { class_name: '我要报名', id: 4 },
        { class_name: '我的投稿', id: 5 },
        { class_name: '设计咨询', id: 6 }
      ],
      hxList: [
        { class_name: '我的预约', id: 7 },
      ],
      showActivitySignup: false,
      showDesignSignup: false
    }
  },
  computed: { },
  watch: {},
  created() {
    },
  mounted() {
    this.$route.query.classIndex && this.selClass(~~this.$route.query.classIndex)
  },
  methods: {
    userImg() {
      if (this.userInfo.headpic) {
        return this.userInfo.headpic
      } else {
        return require('@/assets/index/login-icon.png')
      }
    },
    afterReadheadPic(file) {
      upload(file.file).then((res) => {
        if (res.result === 1) {
          const form = {
            ...this.userInfo,
            headpicUrl: res.fileLink,
            headpic: res.fileLink
          }
          editInfo({...form}).then(res => {
            if (res.result === 1) {
              res.token = localStorage.getItem('token')
              res.key = localStorage.getItem('key')
              res.deskey = localStorage.getItem('deskey')
              res.validity_time = localStorage.getItem('validity_time')
              this.$emit('saveGiftsUser', res)
            } else {
              this.$message(res.msg)
            }
          })
        } else {
          this.$message(res.msg)
        }
      }).catch((err) => console.log(err))
    },
    selClass(id) {
      if (this.classIndex !== id) {
        this.classIndex = id
      }
      if (id === 1) {
        this.showActivitySignup = true
        return
      }
      if (id === 4) {
        this.showDesignSignup = true
        return
      }
    },

    editUserInfo() {
      this.$emit('editUserInfo', true)
    }
  }
}
</script>
<style lang='less' scoped>
.mine {
  max-width: 1920px;
  margin: 0 auto;
  .title{
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 1920px;
    height: 440px;
    background: url('../../assets/mine/tittle.png') no-repeat;
    background-size: 100% 100%;
  }

  .proBox{
    width: 1440px;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 48px 241px 0 238.5px;
    margin-bottom: 40px;

    .proClass{
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      width: 240px;
      height: 430px;
      background: #FFFFFF;
      box-shadow: 0px 0px 18px 0px rgba(216,216,216,0.75);
      border-radius: 15px;
      padding-bottom: 30px;
      .classTit{
        user-select: none;
        font-size: 25px;
        color: #4E8B46;
        height: 80px;
        line-height: 100px;
      }
      .classItem{
        width: 160px;
        text-align: center;
        height: 50px;
        line-height: 53px;
        font-size: 20px;
        border-radius: 25px;
        color: #4E8B46;
        cursor: pointer;
      }
      .selItem{
        border-radius: 25px;
        color: #fff;
        background: #4E8B46;
      }
    }

    .proList{
      width: 1160px;
      margin-left: 40px;
      .user_info{
        box-sizing: border-box;
        display: flex;
        align-items: center;
        width: 100%;
        height: 150px;
        background: #F5F8F4;
        border: 1px solid #B8D4B4;
        border-radius: 15px;
        padding: 0 60px;
        font-size: 20px;
        .img{
          padding: 6px;
          width: 100px;
          height: 100px;
          border: 1px solid #52914C;
          border-radius: 50%;
          img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
          }
        }
        .nick{
          flex: 1;
          font-size: 24px;
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          color: #4E8B46;
          padding: 0 20px;
          text-align: left;
        }
        .tx{
          cursor: pointer;
          border: 0;
          width: 100px;
          height: 40px;
          line-height: 40px;
          background: #4E8B46;
          border-radius: 4px;
          color: #FFFFFF;
        }
        .msg{
          cursor: pointer;
          border: 0;
          width: 160px;
          height: 40px;
          line-height: 40px;
          background: #4E8B46;
          border-radius: 4px;
          color: #FFFFFF;
          margin-left: 24px;
        }
      }

    }
  }
}
</style>
